import type {
  Coverage,
  PolicyHolder,
  Quote,
  WebShopPublicUser,
} from "@/api_client";

import { quoteIndicatesUserMoving } from "../utils/quoteIndicatesUserMoving";
import customer from "./data/customer";
import insuranceInfo from "./data/insuranceInfo";
import objectInfo from "./data/objectInfo";
import type { InsuranceInformationUpdated } from "./types/types";

export const createInsuranceInformationUpdated = (
  contextId: string,
  product: Quote,
  enigmatizedProduct: Quote | undefined,
  enigmatizedPolicyHolder: PolicyHolder | undefined | null,
  user: WebShopPublicUser | undefined,
  coverageContent: Record<string, Coverage> | undefined,
): InsuranceInformationUpdated | undefined => {
  if (!product || !enigmatizedPolicyHolder) {
    return;
  }
  const event: InsuranceInformationUpdated = {
    event: "Insurance Information Updated",
    objectInfo: [
      objectInfo.getObjectInfo(
        enigmatizedPolicyHolder,
        product,
        enigmatizedProduct,
      ),
    ],
    customerInfo: customer.getCustomerInfo(
      enigmatizedPolicyHolder,
      user,
      quoteIndicatesUserMoving([product]),
    ),
    insuranceInfo: [
      insuranceInfo.getInsuranceInfo(contextId, product, coverageContent),
    ],
  };

  return event;
};
